const casesSingleInit = () => {
  const btn = document.querySelector(".cases__top .c-btn");
  const text = document.querySelector(".cases__top p");
  const title = document.querySelector(".cases__top h1");

  gsap.registerPlugin(ScrollTrigger);

  if (btn) {
    gsap.fromTo(
      btn,
      {
        opacity: 0,
        y: "100px",
        scrollTrigger: {
          trigger: btn,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      },
      {
        opacity: 1,
        y: "0",
        scrollTrigger: {
          trigger: btn,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      }
    );
  }

  if (title) {
    gsap.fromTo(
      title,
      {
        opacity: 0,
        y: 100,
        delay: 0.2,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      },
      {
        opacity: 1,
        y: "0",
        delay: 0.2,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      }
    );
  }

  if (text) {
    gsap.fromTo(
      text,
      {
        opacity: 0,
        y: 100,
        delay: 0.1,
        scrollTrigger: {
          trigger: text,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      },
      {
        opacity: 1,
        y: "0",
        delay: 0.1,
        scrollTrigger: {
          trigger: text,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      }
    );
  }
};

document.addEventListener("DOMContentLoaded", function () {
  casesSingleInit();
});
